<template>
    <router-view></router-view>
</template>

<script>
    export default {};
</script>

<style lang="scss">
    @import "normalize.css";

    * {
        box-sizing: border-box;
    }

    body {
        font-family: "Roboto", sans-serif;
        font-size: 1.125rem;
        letter-spacing: 0.03125rem;
        line-height: 1.4;
        color: #333333;
        background-color: rgba(127, 210, 232, 0.12);
    }

    .o-shell {
        max-width: 1400px;
        padding: 0 2% 5% 2%;
        margin: 0 auto;
    }

    h1 {
        font-family: "Montserrat", sans-serif;
        font-size: 2rem;
        color: #333333;
        font-weight: 600;
    }

    h5 {
        font-size: 0.85rem;
        font-weight: 500;
    }

    a {
        color: #0087ab;
        font-size: 0.85rem;
        text-decoration: none;
        text-transform: uppercase;
    }
</style>
